import type { DutyAnalyticsMetric } from '@pams/shared';
import { Link } from 'react-router';
import { formatCount } from '@/lib/analyticsReport';

/**
 * ⚠️ [P7C §2] A NON-ZERO COUNT OPENS ITS ROWS; A ZERO IS PLAIN TEXT (§2j). A link to a list guaranteed
 * empty is a promise the next click breaks — [P6a]'s "zero does not link". The accessible name starts
 * with the visible number (WCAG 2.5.3) and says what it counts and for whom, because a column of
 * digits is otherwise eight identical "3" links to a screen reader.
 *
 * ⚠️ `data-metric` ON BOTH ARMS, so a browser claim can address a cell by what it counts whether or not
 * it links.
 */
export const CountLink = ({
  value,
  metric,
  href,
  label,
}: {
  value: number;
  metric: DutyAnalyticsMetric;
  href: string | undefined;
  label: string;
}) =>
  value > 0 && href !== undefined ? (
    <Link
      to={href}
      data-metric={metric}
      aria-label={label}
      className="text-link tabular-nums underline-offset-4 hover:underline"
    >
      {formatCount(value)}
    </Link>
  ) : (
    <span data-metric={metric} className="tabular-nums">
      {formatCount(value)}
    </span>
  );
